import { notNullOrUndefined } from './ts-guard';
import { NullOrUndefined } from './ts-type';

export function joiner(arr: (string | NullOrUndefined)[], sep: string = ' ● '): string {
  return arr
    .filter(notNullOrUndefined)
    .filter(v => v.trim() !== '')
    .join(sep);
}
